<template>
  <div :class="[$style.stats, { [$style.statsFromPodium]: fromPodium }]">
    <div :class="$style.stat">
      <ui-icon name="darts" :class="$style.icon" />
      <span :class="$style.value">{{ formattedCorrect }}</span>
      <span v-if="isShowPicksTotal" :class="$style.total">
        / {{ formattedPicksTotal }}
      </span>
    </div>
    <div :class="$style.stat">
      <ui-icon name="xp" :class="[$style.icon]" />
      <span :class="$style.value">{{ formattedXp }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import UiIcon from '@/ui-core/components/icon/index.vue'
import { usePickemCounter } from '../../composables/use-pickem-counter'

defineOptions({ name: 'PickemLeaderBoardRowStats' })

const props = defineProps<{
  xp: number
  correctCount: number
  picksTotal?: number
  fromPodium?: boolean
}>()

const { $matchMedia } = useNuxtApp()

const isMobile = computed(() => $matchMedia.down('sm'))
const isPicksTotalDefined = computed(
  () => props.picksTotal != null && props.picksTotal > 0
)
const isShowPicksTotal = computed(
  () => isPicksTotalDefined.value && (isMobile.value ? props.fromPodium : true)
)

const { formatted: formattedXp } = usePickemCounter(() => props.xp)
const { formatted: formattedCorrect } = usePickemCounter(
  () => props.correctCount
)
const { formatted: formattedPicksTotal } = usePickemCounter(
  () => props.picksTotal ?? 0
)
</script>

<style lang="scss" module>
.stats {
  display: flex;
  align-items: center;
  gap: 1.6em;
  flex-shrink: 0;

  @include down(sm) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.4em;
  }

  &.statsFromPodium {
    @include down(sm) {
      gap: 0.4em 1.6em;
    }
  }
}

.stat {
  display: inline-flex;
  align-items: center;
  gap: 0.4em;
  min-width: 0;
}

.icon {
  width: 1.6em;
  height: 1.6em;
  flex-shrink: 0;
  color: color-get(--root-rgb-text-2);

  @include down(sm) {
    width: 1.4em;
    height: 1.4em;
  }
}

.value {
  @include typo-get(body-m);
  color: color-get(--root-rgb-text-2);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  @include down(sm) {
    @include typo-get(subhead-s);
  }
}

.total {
  @include typo-get(subhead-m);
  color: color-get(--root-rgb-text-3);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  @include down(sm) {
    @include typo-get(subhead-s);
  }
}
</style>
